import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ArrayHelper } from 'foundation/helpers';
import { SpriteSvg } from 'shared/sprite-svg';

class CategorySelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedCategories: props.selectedCategories || [],
            isExpanded: false,
        };
        this.contentRef = React.createRef();
        this.rootRef = React.createRef();
    }

    componentDidMount() {
        document.addEventListener('click', this.onDocumentInteraction);
        document.addEventListener('touchstart', this.onDocumentInteraction);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.onDocumentInteraction);
        document.removeEventListener('touchstart', this.onDocumentInteraction);
    }

    onDocumentInteraction = (e) => {
        if (this.state.isExpanded && !this.rootRef.current.contains(e.target)) {
            this.setState({ isExpanded: false });
        }
    };

    toggleVisibility = () => {
        this.setState(
            { isExpanded: !this.state.isExpanded },
            () => {
                if (this.state.isExpanded) {
                    this.contentRef.current.focus();
                }
            }
        );
    };

    toggleCategory = (categoryId, isSelected) => {
        const { selectedCategories } = this.state;

        if (isSelected) {
            this.setState({
                selectedCategories: selectedCategories.filter((selectedCategoryId) =>
                    selectedCategoryId !== categoryId)
            });
        } else {
            this.setState({
                selectedCategories: [...selectedCategories, categoryId]
            });
        }
    };

    onClickClear = () => {
        this.setState({ selectedCategories: [] });
    };

    onClickApply = () => {
        this.setState({ isExpanded: false });
        this.props.onApply(this.state.selectedCategories);
    };

    render() {
        const { childCss, categories } = this.props;

        if (ArrayHelper.isEmpty(categories)) return null;

        const { selectedCategories, isExpanded } = this.state;
        const counter = selectedCategories.length;
        const stateCss = classNames({
            'is-expanded': isExpanded,
            'has-selected': !!selectedCategories.length
        });

        return (
            <div className={`${childCss} category-selector ${stateCss}`} ref={this.rootRef}>
                <button
                    className="category-selector__trigger"
                    type="button"
                    onClick={this.toggleVisibility}
                    aria-label="toggle categories list visibility"
                >
                    <span>Category</span>
                    {
                        counter > 0 &&
                        <span className="category-selector__counter">{counter}</span>
                    }
                    <SpriteSvg iconName={'chevron-down'} width={10} height={5} />
                </button>
                <div className="category-selector__content" ref={this.contentRef} tabIndex={0}>
                    <ul className="category-selector__list">
                        {
                            categories.map((category) => {
                                const isSelected = selectedCategories.includes(category.categoryId);

                                return (
                                    <li className="category-selector__category form-field form-field--checkbox" key={category.categoryId}>
                                        <input
                                            className=" form-field__checkbox visually-hidden"
                                            id={category.categoryId}
                                            type="checkbox"
                                            checked={isSelected}
                                            onChange={() => this.toggleCategory(category.categoryId, isSelected)}
                                        />
                                        <label className="form-field__label" htmlFor={category.categoryId}>{category.categoryName}</label>
                                    </li>
                                );
                            })
                        }
                    </ul>
                    <div className="category-selector__footer">
                        <button
                            className="link"
                            type="button"
                            onClick={this.onClickClear}
                            aria-label="clear selected categories"
                        >Clear
                        </button>
                        <button
                            className="category-selector__apply base-btn base-btn--violet-blue"
                            type="button"
                            onClick={this.onClickApply}
                            aria-label="apply selected categories"
                        >Apply
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

CategorySelector.defaultProps = {
    childCss: '',
    onClear: () => {},
    onApply: () => {},
};

CategorySelector.propTypes = {
    categories: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            title: PropTypes.string,
            isSelected: PropTypes.bool,
        })
    )
};

export default CategorySelector;
